
import { Prop, Vue, Component } from 'vue-property-decorator';

@Component
export default class LargeCTABackgroundPanel extends Vue {
  @Prop({ type: Object, required: true }) readonly images!: {
    [key: string]: string;
  };
  @Prop({ type: String, default: 'right top' }) readonly bgPosition!: string;
  private componentKey: string = `${Math.random().toString(36).substr(2, 9)}`;
  private breakpoints: { [key: string]: string } = {
    sm: '600px',
    md: '960px',
    lg: '1264px',
    xl: '1904px',
  };

  get componentDataKey() {
    return this.componentKey;
  }
  mounted() {
    this.injectStyles();
  }

  beforeDestroy() {
    this.removeStyles();
  }

  injectStyles() {
    const styleContent = this.generateStyleContent();
    const styleTag = document.createElement('style');
    styleTag.textContent = styleContent;
    styleTag.id = `large-cta-${this.componentKey}`; // Dynamically generate unique id
    document.head.appendChild(styleTag);
  }

  get hasHeader() {
    return !!this.$slots.header;
  }

  get hasSubhead() {
    return !!this.$slots.subhead;
  }

  get hasCTALink() {
    return !!this.$slots.ctaLink;
  }

  get hasRightContent() {
    return !!this.$slots.rightContent;
  }

  removeStyles() {
    const styleTag = document.getElementById(`large-cta-${this.componentKey}`);
    if (styleTag) {
      styleTag.remove();
    }
  }

  generateStyleContent() {
    let styleString = '';

    styleString += `.large-background-cta[data-key="${
      this.componentKey
    }"] { --default-image: url(${this.images[Object.keys(this.images)[0]]})}`;
    styleString += Object.keys(this.images)
      .map((key) => {
        const breakpointValue = this.breakpoints[key];
        return `@media (min-width: ${breakpointValue}) { .large-background-cta[data-key="${this.componentKey}"] { --default-image: url(${this.images[key]}); } }`;
      })
      .join('\n');

    return styleString;
  }
}
